export default (propertyName: string): string | undefined => {
  const mountParent: Element = document.getElementsByTagName(
    'bugherd-sidebar'
  )[0];

  return mountParent.getAttribute(`data-${propertyName}`);
};
